export const GET_LIST_SURVEY_BY_CLIENT_SUCCESS = 'GET_LIST_SURVEY_BY_CLIENT_SUCCESS';
export const GET_SURVEY_BY_CLIENT_SUCCESS = 'GET_SURVEY_BY_CLIENT_SUCCESS';
export const GET_SURVEY = 'GET_SURVEY';
export const SHOW_REVIEWS_CHANGE = 'SHOW_REVIEWS_CHANGE';

/**
 * It returns an object with a type and content property. 
 * 
 * The type property is a string that is the same as the constant GET_LIST_SURVEY_BY_CLIENT_SUCCESS. 
 * 
 * The content property is the content parameter that was passed into the function.
 * @param content - {
 * @returns An object with a type and content.
 */
const ListSurveysClientByIdSuccess = (content) => {
	return {
		type: GET_LIST_SURVEY_BY_CLIENT_SUCCESS,
		content
	}
} 

/**
 * It returns an object with a type and a content property.
 * @param content - {
 * @returns An object with a type and content.
 */
const GetSurveyByIdClientSuccess = (content) => {
    return {
        type: GET_SURVEY_BY_CLIENT_SUCCESS ,
        content
    }
}

const UpdateSurvey = (content) => {
    return {
        type: GET_SURVEY ,
        content
    }
}

/**
 * This function returns an object with a type property of SHOW_REVIEWS_CHANGE.
 * @returns An object with a type property.
 */
 const onChangeReviews = () => {
	return {
		type: SHOW_REVIEWS_CHANGE
	}
} 


export {
    ListSurveysClientByIdSuccess,
    GetSurveyByIdClientSuccess,
    UpdateSurvey,
    onChangeReviews
}